import axios from 'axios';

// Users of one event, each with a role (admin, owner, ticket control)
export const getEventUsers = (eventId) => axios.get(`/user/admin/${eventId}/users`);
// Accounts from the admin's other events that could be given a role on this one
export const getEventUserCandidates = (eventId) => axios.get(`/user/admin/${eventId}/users/available`);
export const createEventUser = (eventId, data) => axios.post(`/user/admin/${eventId}/users`, data);
export const updateEventUser = (eventId, id, data) => axios.put(`/user/admin/${eventId}/users/${id}`, data);
export const deleteEventUser = (eventId, id) => axios.delete(`/user/admin/${eventId}/users/${id}`);
